import Vue from 'vue';
import Vuex from 'vuex';
import axios from 'axios';

// 사용자 정의 모듈.
import * as config from './config';

Vue.use(Vuex);

const createAxiosParams = (store, payload) => {
    // store_id 공통 설정.
    // if (payload.type.method == 'get') {
    // } else {
    // }

    // 서버 요청 파라미터 생성.
    const reqURL = store.getters['getHost'] + payload.type.url;
    const reqData = (payload.type.method == 'get') ? { params: payload.data } : payload.data;
    const reqHeaders = { headers: { 'x-access-token': store.getters['getToken'] } };

    let axiosParams = new Object();
    axiosParams.reqURL = reqURL;
    axiosParams.reqData = reqData;
    axiosParams.reqHeaders = reqHeaders;
    axiosParams.payload = payload;

    // console.log('axiosParams :: ', axiosParams);

    return axiosParams;
}
const getAxiosInsctance = (axiosParms) => {
    if (axiosParms.payload.type.method == 'get') {
        return axios[axiosParms.payload.type.method](axiosParms.reqURL, Object.assign({}, axiosParms.reqData, axiosParms.reqHeaders));
    } else {
        return axios[axiosParms.payload.type.method](axiosParms.reqURL, axiosParms.reqData, axiosParms.reqHeaders);
    }
}

export default new Vuex.Store({
    state: {
        host: config.HOST,
        page: 'home',
        last_page : '',
        params: {},
        user_info:{
            m_user_id:'',
            user_id: '',
            name:'',
            user_hp:'',
            parents_hp:'',
            memo:'',
            agree_yn:'',
            join_datetime:'',
            age:'',
            sex:'',
            address:'',
            address_detail:''
        },
        login_chk:false,
        popup_type: {
            code: 0,
            message: '',
            router: '',
            image_type: ''
        },
        popup_code: {
            TEXT: 1, // 일반 TEXT 팝업
            TABLE: 2, // 테이블 팝업
            MAP:3, // 지도 팝업
            TAB_TABLE: 4, // 탭 테이블 팝업
        },
        location_info: {
            my_lat: '',
            my_lon: ''
        },
        component_refs: {},
        detail_sel_store_id:'',
        callbackFunc: {},
        loading: false,
        token: ''
    },

    getters: {
        getDetail_sel_store_id: function (state) {
            return state.detail_sel_store_id;
        },
        getLogin_chk: function (state) {
            return state.login_chk;
        },
        getUser_info: function (state) {
            return state.user_info;
        },
        getHost: function (state) {
            return state.host;
        },
        getCurrentPage: function (state) {
            return state.page;
        },
        getLastPage: function(state) {
            return state.last_page;
        },
        getParams: function(state) {
            return state.params;
        },
        getLocation: function(state) {
            return state.location_info;
        },
        getComponentRefs: function(state) {
            return state.component_refs;
        },
        getCallbackFunc: function(state) {
            return state.callbackFunc;
        },
        getLoading: function(state){
            return state.loading;
        },
        getToken: function (state) {
            return state.token;
        },
    },
    mutations: {
        setDetail_sel_store_id(state, value) {
            state.detail_sel_store_id = value;
        },
        setLogin_chk(state, value) {
            state.login_chk = value;
        },
        setUser_info(state, value) {
            state.user_info = value;
        },
        setCurrentPage(state, value) {
            state.page = value;
        },
        setLastPage(state, value) {
            state.last_page = value;
        },
        setParams: function(state, value) {
            state.params = value;
        },
        setLocation: function(state, value) {
            state.location_info = value;
        },
        setComponentRefs: function(state, value) {
            state.component_refs = value;
        },
        setCallbackFunc: function(state, value) {
            state.callbackFunc = value;
        },
        setLoading: function(state, value){
            state.loading = value;
        },
        set_token(state, value) {
            state.token = value;
        },
    },
    // setTimeout() 이나 서버와의 http 통신 처리 같이 결과를 받아올 타이밍이 예측되지 않은 로직
    actions: {
        [config.ACT_GET_INIT_DATA](store) {
            const payloadArray = [];
            payloadArray.push({type: config.REQ_USER_LOGIN});

            return store.dispatch(
                config.ACT_SERVER_REQUEST_ALL, payloadArray
            ).then(function (responseList) {
                responseList.forEach((response, index) => {
                    // 갱신된 token 점검.
                if (responseList[0].data.hasOwnProperty('token') && responseList[0].data.hasOwnProperty('token_type')) {
                    let response = responseList[0];
                    switch (response.data.token_type.code) {
                        case 1:
                            // user
                            store.commit('set_token', {
                                vo: response.data.token
                            });
                            break;
                        /* case 2:
                            // kiosk
                            store.commit('set_store_token', {
                                vo: response.data.token
                            });
                            break; */
                    }
                }
                });

            }).catch(function (error) {
                console.log('error=============>', error);
                return error;
            });
        },


        /**
         * 사용방법 - 아래 내용 복사 하여 type 및 data 수정하여 요청.
         * // 좌석 정보 요청.
            const type = config.REQ_SEAT_TAB_GET_LIST;
            const data = {}; // store_id는 공통으로 추가하니까 생략. 예) {user_id: 123}
            this.$store.dispatch(type.action_name, {
                type: type,
                data: data
            }).then(function (response) {
                console.log(response.data);
            }).catch(function (error) {
                console.log('error=============>',error);
            });

            // 여러건 호출
            Promise.all(
                [
                    this.$store.dispatch(type.action_name, {
                        type: type,
                        data: data
                    }),
                    this.$store.dispatch(type.action_name, {
                        type: type,
                        data: data
                    })
                ]
            ).then(function (responseList) {
                // 응답 - 요청 순서별 응답 array
                console.log(responseList);
            }).catch(function (error) {
                console.log('error=============>', error);
            });
         * @param {*} store
         * @param {*} payload - {type:type, data:data}
         */
        [config.ACT_SERVER_REQUEST](store, payload) {
            if (!payload.type) {
                return Promise.reject(new Error('[store > actions] 호출시 반드시 type을 설정하셔야 합니다.'));
            }

            // axios parameter 생성.
            const axiosParms = createAxiosParams(store, payload);
            if (payload.type.method == 'get') {
                return axios[payload.type.method](
                    axiosParms.reqURL, Object.assign({}, axiosParms.reqData, axiosParms.reqHeaders)
                )
                    .then(function (response) {
                        // console.dir(response);

                        // 갱신된 token 점검.
                        if (response.data.hasOwnProperty('token') && response.data.hasOwnProperty('token_type')) {
                            switch (response.data.token_type.code) {
                                case 1:
                                    // user
                                    store.commit('set_token', {
                                        vo: response.data.token
                                    });
                                    break;
                                /* case 2:
                                    // kiosk
                                    store.commit('set_store_token', {
                                        vo: response.data.token
                                    });
                                    break; */
                            }
                        }

                        return response.data;
                    })
                    .catch(function (error) {
                        // console.log(error);
                        return error;
                    });
            } else {
                return axios[payload.type.method](
                    axiosParms.reqURL, axiosParms.reqData, axiosParms.reqHeaders
                )
                    .then(function (response) {
                        return response.data;
                    })
                    .catch(function (error) {
                        // console.log(error);
                        return error;
                    });
            }
        },
        async [config.ACT_SERVER_REQUEST_ASYNC](store, payload) {
            if (!payload.type) {
                return Promise.reject(new Error('[store > actions] 호출시 반드시 type을 설정하셔야 합니다.'));
            }
            //console.log('payload ==>', payload);
            // axios parameter 생성.
            const axiosParms = createAxiosParams(store, payload);
            //console.log('axiosParms ==>', axiosParms);
            let response;
            if (payload.type.method == 'get') {
                response = await axios[payload.type.method](axiosParms.reqURL, Object.assign({}, axiosParms.reqData, axiosParms.reqHeaders));
            } else {
                response = await axios[payload.type.method](axiosParms.reqURL, axiosParms.reqData, axiosParms.reqHeaders);
            }
            //console.log('first response  ==>', response);
             // 갱신된 token 점검.
            if (response.data.hasOwnProperty('token') && response.data.hasOwnProperty('token_type')) {
                switch (response.data.token_type.code) {
                    case 1:
                        // user
                        store.commit('set_token', {
                            vo: response.data.token
                        });
                        break;
                    /* case 2:
                        // kiosk
                        store.commit('set_store_token', {
                            vo: response.data.token
                        });
                        break; */
                }
            }

            return response.data;
        },
        /**
         * 사용방법 - 아래 내용 복사 하여 type 및 data 수정하여 요청.
         * // 좌석 정보 요청.
              const payloadArray = [{type:config.REQ_SEAT_TAB_GET_LIST, data:{}}, {type:config.REQ_SEAT_TAB_GET_LIST, data:{}}];
              this.$store.dispatch(
                  config.ACT_SERVER_REQUEST_ALL, payloadArray
              ).then(function (responseList) {
                  console.log(responseList);
              }).catch(function (error) {
                  console.log('error=============>', error);
              });
           * @param {*} store
           * @param {*} payloadArray - [{type:type, data:data}]
         */
        [config.ACT_SERVER_REQUEST_ALL](store, payloadArray) {
            payloadArray.forEach(function (payload) {
                if (!payload.type) {
                    return Promise.reject(new Error('[store > actions] 호출시 반드시 type을 설정하셔야 합니다.'));
                }
            });

            // axios parameter 생성.
            const axiosParmsArray = payloadArray.map(function (payload) {
                return createAxiosParams(store, payload);
            });

            // axios all 호출
            return axios.all(axiosParmsArray.map((axiosParms) => {
                return getAxiosInsctance(axiosParms);
            }))
                .then(responseArr => {
                    // 갱신된 token 점검.
                    if (responseArr[0].data.hasOwnProperty('token') && responseArr[0].data.hasOwnProperty('token_type')) {
                        let response = responseArr[0];
                        switch (response.data.token_type.code) {
                            case 1:
                                // user
                                store.commit('set_token', {
                                    vo: response.data.token
                                });
                                break;
                            /* case 2:
                                // kiosk
                                store.commit('set_store_token', {
                                    vo: response.data.token
                                });
                                break; */
                        }
                    }

                    //this will be executed only when all requests are complete
                    var responseList = responseArr.map(function (response) {
                        return response.data;
                    });
                    return responseList;
                }).catch((error) => {
                    // console.error(error);
                    return error;
                });
        },
    }
});



// WEBPACK FOOTER //
// ./src/js/store.js